import React from "react";
import RightHandSide from "../../Common/Services/RightHandSide";
import AboutInnBanContent from "../../Common/InnerBanner/AboutInnBanContent";
import { AboutInnerBanner } from "../../Common/InnerBanner/AboutInnerBanner";
import HeadContent from "../BlogContent/HeadContent";
import HeadDesign from "../BlogContent/HeadDesign";
import Info from "../BlogContent/Info";
import List from "../BlogContent/List";
import InfoContent from "../BlogContent/InfoContent";
import ListContent from "../BlogContent/ListContent";
import RecentBlogsList from "../BlogContent/RecentBlogsList";
import { Helmet } from "react-helmet";

const Blog39 = () => {
  const { image, heading, pageName } = AboutInnBanContent.BlogDetails;
  const { bg, para, date, blogHeading } = HeadContent.blog_39;

  const { title, p } = InfoContent.Blog_39.one;
  const { title2, p2 } = InfoContent.Blog_39.two;
  const { title3, p3 } = InfoContent.Blog_39.three;
  const { title4, p4 } = InfoContent.Blog_39.four;
  const { title5, p5 } = InfoContent.Blog_39.five;
  const { Ctitle, Cp } = InfoContent.Blog_39.conclusion;
  const { title6, p6 } = InfoContent.Blog_39.six;
  const { title7, p7 } = InfoContent.Blog_39.seven;
  const { titlefaq, pfaq } = InfoContent.Blog_39.FAQ;
  const { title8, p8 } = InfoContent.Blog_39.eight;

  //   const { liss1 } = ListContent.Blog_39.L1;
  //   const { liss3 } = ListContent.Blog_39.L3;

  return (
    <>
      <Helmet>
        <title>Smoking and Sperm Quality: Effects on Male Fertility</title>

        <meta
          name="description"
          content="Learn how smoking can affect sperm count, movement, shape and DNA, and what men can do to support healthier sperm when planning pregnancy."
        />

        <meta
          name="keywords"
          content="smoking and sperm quality, smoking effects on sperm, smoking and male fertility, smoking and sperm count, smoking and sperm motility, smoking and sperm morphology, does smoking reduce sperm count, does smoking cause male infertility, smoking effects on male fertility, vaping and sperm health, vaping and male fertility, smoking and sperm DNA, how smoking affects sperm, quit smoking for sperm health, male infertility causes"
        />

        <link
          rel="canonical"
          href="https://www.acmefertility.com/39/Smoking-and-Sperm-Quality-What-Every-Man-Should-Know"
        />

        {/* Article Schema */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Article",
            "@id":
              "https://www.acmefertility.com/39/Smoking-and-Sperm-Quality-What-Every-Man-Should-Know#article",
            mainEntityOfPage: {
              "@type": "WebPage",
              "@id":
                "https://www.acmefertility.com/39/Smoking-and-Sperm-Quality-What-Every-Man-Should-Know",
            },
            headline: "Smoking and Sperm Quality: What Every Man Should Know",
            description:
              "Learn how smoking can affect sperm count, movement, shape and DNA, and what men can do to support healthier sperm when planning pregnancy.",
            author: {
              "@type": "Organization",
              name: "Acme Fertility",
              url: "https://www.acmefertility.com/",
            },
            publisher: {
              "@type": "Organization",
              name: "Acme Fertility",
              url: "https://www.acmefertility.com/",
              logo: {
                "@type": "ImageObject",
                url: "https://www.acmefertility.com/logo.png",
              },
            },
            articleSection: [
              "Male Fertility",
              "Sperm Health",
              "Male Infertility",
              "Fertility",
            ],
            keywords: [
              "smoking and sperm quality",
              "effects of smoking on male fertility",
              "sperm count and smoking",
              "does smoking cause male infertility",
              "vaping and sperm health",
            ],
            inLanguage: "en-IN",
          })}
        </script>

        {/* Author Schema */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "MedicalBusiness",
            "@id": "https://www.acmefertility.com/#medicalbusiness",
            name: "Acme Fertility",
            url: "https://www.acmefertility.com/",
            telephone: "+91-8655006567",
            address: {
              "@type": "PostalAddress",
              streetAddress:
                "402, 4th Floor, Signature Business Park, Postal Colony Road, Near Chembur Mono Rail Station",
              addressLocality: "Mumbai",
              postalCode: "400071",
              addressCountry: "IN",
            },
            description:
              "Acme Fertility provides fertility evaluation, IVF, ICSI, IUI, male infertility care and reproductive health services.",
            knowsAbout: [
              "Male Fertility",
              "Sperm Health",
              "Male Infertility",
              "In Vitro Fertilization",
              "IVF Treatment",
              "ICSI",
              "IUI",
              "Reproductive Health",
            ],
          })}
        </script>

        {/* FAQ Schema */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "FAQPage",
            "@id":
              "https://www.acmefertility.com/39/Smoking-and-Sperm-Quality-What-Every-Man-Should-Know#faq",
            mainEntity: [
              {
                "@type": "Question",
                name: "Does smoking reduce sperm count?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Yes. Smoking has been associated with reduced sperm concentration, although the effect varies between individuals.",
                },
              },
              {
                "@type": "Question",
                name: "Does smoking affect sperm motility?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Yes. Smoking has been associated with poorer sperm movement.",
                },
              },
              {
                "@type": "Question",
                name: "Can smoking cause abnormal sperm?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Research has found an association between smoking and increased sperm morphology abnormalities.",
                },
              },
              {
                "@type": "Question",
                name: "Is vaping safe for sperm?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Current evidence is not strong enough to consider vaping a fertility-safe alternative. Quitting tobacco and nicotine exposure is recommended when planning pregnancy.",
                },
              },
              {
                "@type": "Question",
                name: "Can quitting smoking improve sperm quality?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Potentially, yes. Quitting removes an important source of toxic exposure, allowing the body to produce new sperm. However, because sperm development takes time, improvements should not be expected immediately.",
                },
              },
            ],
          })}
        </script>
        {/* Breadcrumb Schema */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            "@id":
              "https://www.acmefertility.com/39/Smoking-and-Sperm-Quality-What-Every-Man-Should-Know#breadcrumb",
            itemListElement: [
              {
                "@type": "ListItem",
                position: 1,
                name: "Home",
                item: "https://www.acmefertility.com/",
              },
              {
                "@type": "ListItem",
                position: 2,
                name: "Fertility",
                item: "https://www.acmefertility.com/Fertility.php",
              },
              {
                "@type": "ListItem",
                position: 3,
                name: "Smoking and Sperm Quality",
                item: "https://www.acmefertility.com/39/Smoking-and-Sperm-Quality-What-Every-Man-Should-Know",
              },
            ],
          })}
        </script>
      </Helmet>

      <AboutInnerBanner image={image} heading={heading} pageName={pageName} />

      <div className="blog-area pt-100 pb-70">
        <div className="container">
          <div className="row">
            <div className="col-lg-8">
              <HeadDesign
                bg={bg}
                para={para}
                date={date}
                blogHeading={blogHeading}
              />
              <Info title={title} p={p} />
              <Info title={title2} p={p2} />
              <Info title={title3} p={p3} />
              <Info title={title4} p={p4} />
              <Info title={title5} p={p5} />

              <Info title={title6} p={p6} />
              <Info title={title7} p={p7} />
              <Info title={titlefaq} p={pfaq} />
              <Info title={title8} p={p8} />
              {/*
                 <Info title={Ctitle} p={Cp} />
                <List liss={liss1} />
                
                
                <List liss={liss3} />
               
              */}
            </div>

            <div className="col-lg-4">
              <RecentBlogsList />
              <RightHandSide />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Blog39;
